/**
 * Created by Sergey Shoshin on 2017-04-19.
 */
import { Injectable } from '@angular/core';

@Injectable()
export class AddressAutocompleteModel {
    public enabled: boolean;
    public country: number;
    public city: string;
    public province: string;
    public zip: string;
    public countryCode: string;

    public address1: string;
    public address2: string;

    /* added for settings tab in account page */
    public lastName: string;
    public firstName: string;
    public phone = '';
    public postalCode: string;
    public countryFullname: string;

    public addressInline = '';
}


// WEBPACK FOOTER //
// ./src/app/shared/components/autocomplete/address-autocomplete.model.ts